var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tips"},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" 正在登录王选所内部信息系统... ")])])])
}]

export { render, staticRenderFns }